<white-board [isLogo]="false" class="client-white-board" [template]="template" />
<ng-template #template>
  <router-outlet />
</ng-template>
